export default __webpack_public_path__ + "static/media/Foto-18.c9035d23.png";